import * as CryptoJS from 'crypto-js';

export class CryptoUtils {

  static encodeBase64(value: string): string {
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(value));
  }

  static decodeBase64(value: string): string {
    return CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(value));
  }

}
